var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"disabled":_vm.value === undefined,"icon":"","color":_vm.value ? 'yellow' : null},on:{"click":_vm.toggle}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.value ? 'mdi-star' : 'mdi-star-outline')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }